import LessonTeach from './component'
export default LessonTeach
